import { render, staticRenderFns } from "./ProjectListRequestee.vue?vue&type=template&id=2b5f105d"
import script from "./ProjectListRequestee.vue?vue&type=script&lang=js"
export * from "./ProjectListRequestee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports